"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ScrollIndicator = _react.default.forwardRef((_ref, ref) => {
  let {
    prefix,
    barPosition,
    barWidth,
    onClick,
    onMouseDown,
    draggable,
    ...other
  } = _ref;
  const positionPercentage = barPosition - barWidth * barPosition / 100;
  const barScale = 100 / barWidth;
  const barPositionScaled = positionPercentage * barScale;
  const barClasses = (0, _classnames.default)(`${prefix}scroll-indicator__bar`, draggable && `${prefix}scroll-indicator__bar-dragging`);
  const scrollIndicatorClassess = (0, _classnames.default)(`${prefix}scroll-indicator`, draggable && `${prefix}scroll-indicator--dragging`);
  return _react.default.createElement("div", _extends({
    className: scrollIndicatorClassess,
    onClick: e => onClick(e),
    tabIndex: "0",
    role: "scrollbar"
  }, other), barWidth > 0 && _react.default.createElement("span", {
    className: `${prefix}scroll-indicator__bar-wrapper`,
    ref: ref
  }, _react.default.createElement("span", {
    className: barClasses,
    style: {
      width: `${barWidth}%`,
      transform: `translateX(${barPositionScaled}%)`
    },
    onMouseDown: e => onMouseDown(e)
  })));
});
ScrollIndicator.displayName = 'ScrollIndicator';
var _default = ScrollIndicator;
exports.default = _default;